import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AdminFleetPage } from '../screens/admin/AdminFleetPage';
import { customersSearch } from '../screens/admin/customers-url';
import { periodSearch } from '../screens/admin/period-search';

/**
 * Everything the Customers page shows is in the URL, so a search, a view, a filter, an order, a page or a
 * period is a link to share (customers-url.ts; the period's params are the admin area's own). Old links
 * with `?view=`, `?q=` or `?partner=` still mean what they meant.
 */
const searchSchema = z.object({ ...customersSearch, ...periodSearch });

export const Route = createFileRoute('/admin/')({
  validateSearch: searchSchema,
  component: AdminFleetPage,
});
